import { capitalize } from 'lodash';
import { AuctionItem, AuctionItemStatus } from 'types/domain';

const didItemEnd = (item: AuctionItem) =>
    (!item.allows_buy_now && item.dashboard_status === 'sold') ||
    item.dashboard_status === 'canceled';

const getFormattedItemStatus = (status: AuctionItemStatus): string => {
    if (status === 'ended') {
        return 'Ending...';
    }
    return capitalize(status);
};

export { didItemEnd, getFormattedItemStatus };
